import '../title.css';

const React = require('react');
const { TipsContainer, RankingContainer, SelectContainer } = require('../modal').default;
const assets = require('../../../assets').default;
const { sound, soundType } = require('../../../core/sound').default;
const gameParamater = require('../../../define/gameParamater').default;
// ============================

export default class titleComponent extends React.Component {
    renderModal() {
        return (
            <div>
                <TipsContainer />
                <SelectContainer />
            </div>
        )
    }

    renderTitle() {
        const { appState: { soundEnable } } = this.props;
        return (
            <div className="title-area">
                <div className="title-logo">
                    <img src={assets.TitleLogo} className="title-img" />
                </div>
                <div className="title-boarder" />
                <div className="title-layout">
                    <div className="title-mea" >
                        <img src={assets.TitleMea} className="title-img" />
                    </div>
                    <div className="title-buttons">
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, soundEnable);
                            this.props.handleTipsClick()
                        }}>TIPS</div>
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, soundEnable);
                            this.props.handleStartClick()
                        }}>GAME START</div>
                        <div className="btn-radius-solid" onClick={() => {
                            sound.playSound(soundType.SE_SELECT_SYSTEM, !soundEnable);
                            this.props.handleSoundClick()
                        }}>SOUND: {soundEnable ? 'ON' : 'OFF'}</div>
                    </div>
                </div>
                <div className="title-boarder" />
                <div className="title-footer">
                    <div className="title-developed">
                        <div>Developed by <a href={'https://twitter.com/souu_array1'} target="_blank">@souu_array1</a></div>
                        <div>Ver {gameParamater.VERSION}</div>
                    </div>
                    <div className="title-copylight">
                        <div>©Gravity Co., Ltd. & LeeMyoungJin(studio DTDS) All rights reserved.</div>
                        <div>©GungHo Online Entertainment, Inc. All Rights Reserved.</div>
                    </div>
                </div>
            </div >
        )
    }


    render() {
        return (<>
            {this.renderModal()}
            {this.renderTitle()}
        </>)
    }
}